import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import AlertIcon from './svg/AlertIcon';

const useStyles = makeStyles((theme: any) => {
  return {
    root: {
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2, 1.5, 1.5, 1.5),
      },
      backgroundColor: theme.palette.error.light,
      border: `1px solid ${theme.palette.error['500']}`,
      padding: theme.spacing(1),
    },
    message: {
      fontWeight: 500,
    },
    alertIcon: {
      marginRight: theme.spacing(1),
    },
  };
});

interface Props {
  message: string;
  action?: React.ReactNode;
}

const AlertError = (props: Props) => {
  const { message, action, ...other } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root} border={2} borderRadius='borderRadius' display='flex' alignItems='flex-start' {...other}>
      <AlertIcon className={classes.alertIcon} viewBox='0 0 26 26' />
      <Box>
        <Typography variant='body1' className={classes.message}>
          {message}
        </Typography>
      </Box>
      <Box style={{ flex: 1, textAlign: 'right' }}>{action}</Box>
    </Box>
  );
};

export default AlertError;
